module.exports = __webpack_public_path__ + "assets/f4294c84b722efa363aa71743692b2ce.png";